import { Text } from '@bechtel/gds';
import { LinkComponentProps } from '../../types';
import { NavLinkStyled } from './styled';

export const LinkCellRenderer = (props: LinkComponentProps) => {
  return (
    <NavLinkStyled
      to={props?.navigationURL ? `/${props?.navigationURL}/${props.data.id}` : `${props.data.id}`}
      target={props?.navigationURL ? '_blank' : undefined}
    >
      <Text color="primary.700" weight={'600'} transform="uppercase">
        {props.value}
      </Text>
    </NavLinkStyled>
  );
};
